import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('clinic_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect to home if user was already logged in (has token) AND
      // this is NOT a login/register request
      const isAuthEndpoint = error.config?.url?.includes('/login') || 
                             error.config?.url?.includes('/register') ||
                             error.config?.url?.includes('/forgot') ||
                             error.config?.url?.includes('/reset');
      
      if (!isAuthEndpoint && localStorage.getItem('clinic_token')) {
        // Session expired - clear token and redirect
        localStorage.removeItem('clinic_token');
        localStorage.removeItem('clinic_user');
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default API;
